import {
  Button,
  Card,
  Grid,
  Icon,
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
import MDBox from "theme/components/MDBox";
import MDTypography from "components/MDTypography";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import DataTable from "theme/Tables/DataTable";

import axios from "axios.js";

function ActivityFootprintsOverview(payload) {
  const { campaignReference } = payload;

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [dailyBreakdown, setDailyBreakdown] = useState([]);
  const [areaCoverage, setAreaCoverage] = useState(0);
  const [distanceTravelled, setDistanceTravelled] = useState(0);
  const [teamBreakdown, setTeamBreakdown] = useState([]);

  const tableColumns = [
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Distance (km)", accessor: "meters", align: "right" },
    // { Header: "Location", accessor: "gps", align: "center" },
  ];

  function buildRows(data) {
    const rows = [];
    data.map((row) => {
      rows.push({
        // gps: <Icon color="error">location_on</Icon>,
        agent: row.agent,
        meters: `${row.meters.toFixed(2)}`,
        // vouchers: row.vouchers,
      });
      return null;
    });

    return rows;
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/campaigns/${campaignReference}/activity/footprints/overview.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setDailyBreakdown(result.data.data.dailyBreakdown);
            setAreaCoverage(result.data.data.areaCoverage);
            setDistanceTravelled(result.data.data.distanceTravelled);
            const rows = buildRows(result.data.data.teamBreakdown);
            setTeamBreakdown(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <MDBox>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={5} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox pt={3} pb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox>
                      <Card sx={{ height: "100%", marginTop: "0px" }}>
                        <MDBox p={2}>
                          <MDBox align="center">
                            <Icon color="warning" fontSize="large">
                              directions_run
                            </Icon>
                          </MDBox>
                          <MDBox>
                            <MDBox align="center">
                              <MDTypography variant="h6" fontWeight="medium" fontSize={26}>
                                {distanceTravelled.toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </MDTypography>
                              <MDTypography fontWeight="light">km</MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                Travelled
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                    <MDBox mt={4.5}>
                      <Card sx={{ height: "100%", marginTop: "0px" }}>
                        <MDBox p={2}>
                          <MDBox align="center">
                            <Icon color="success" fontSize="large">
                              travel_explore
                            </Icon>
                          </MDBox>
                          <MDBox>
                            <MDBox align="center">
                              <MDTypography variant="h6" fontWeight="medium" fontSize={26}>
                                {areaCoverage.toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </MDTypography>
                              <MDTypography fontWeight="light">km</MDTypography>
                              <MDTypography variant="h6" fontWeight="light">
                                Coverage
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={8} lg={8}>
                  {dailyBreakdown !== null && (
                    <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                      <VerticalBarChart
                        icon={{ color: "info", component: "directions_walk" }}
                        title="Distance"
                        description="Daily Travel"
                        chart={{
                          labels: dailyBreakdown.days,
                          datasets: [
                            {
                              label: "Km",
                              color: "dark",
                              data: dailyBreakdown.meters,
                            },
                          ],
                        }}
                      />
                    </MDBox>
                  )}
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <Card>
                <MDBox pb={3}>
                  <DataTable
                    table={{ columns: tableColumns, rows: teamBreakdown }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries={false}
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  );
}

export default ActivityFootprintsOverview;
